import { required } from "@vuelidate/validators";

export default {
  reason: {
    required,
  },
};
